/**
 * Analytics bootstrap.
 *
 * Google Analytics 4, Google Tag Manager, the Google Ads pixel, Meta pixel and
 * PostHog are all loaded (consent-aware) by the unified tag layer in
 * src/lib/marketingTags.js. This module keeps the historical entry points so
 * nothing else in the app needs to change, and adds Microsoft Clarity.
 */
import { initMarketingTags } from "./lib/marketingTags";
import { getConsent, CONSENT_EVENT } from "./lib/cookieConsent";
import { ANALYTICS_IDS } from "./config/analyticsIds";

let clarityConsentListenerAdded = false;

export function initAnalytics() {
  initMarketingTags();
}

/**
 * Initialize Microsoft Clarity heatmap and session recording.
 *
 * Requires REACT_APP_CLARITY_PROJECT_ID (the numeric/alpha project ID from
 * your Clarity dashboard). Clarity is loaded asynchronously and only after the
 * initial page content has rendered, so it does not block LCP.
 */
export function initClarity() {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID || ANALYTICS_IDS.REACT_APP_CLARITY_PROJECT_ID;
  if (!projectId || typeof document === "undefined") return;

  const syncConsent = () => {
    const consent = getConsent();
    if (typeof window.clarity === "function") {
      window.clarity("consentv2", {
        ad_Storage: consent?.marketing ? "granted" : "denied",
        analytics_Storage: consent?.analytics ? "granted" : "denied",
      });
    }
  };
  if (!clarityConsentListenerAdded) {
    clarityConsentListenerAdded = true;
    window.addEventListener(CONSENT_EVENT, syncConsent);
  }
  if (document.getElementById("clarity-script")) {
    syncConsent();
    return;
  }

  const script = document.createElement("script");
  script.id = "clarity-script";
  script.async = true;

  // Clarity loader (official snippet). The IIFE creates window.clarity and
  // appends the tag script to the document head.
  // prettier-ignore
  script.text = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "${projectId}");`;

  document.head.appendChild(script);
  syncConsent();
}
